import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import './App.css';
import Header from './Layouts/Navbar';
import Homepage from './Layouts/Homepage';
import Products from './Components/Products';
import Bombas from './Components/Bombas';
import BombasCentrifugas from './Components/Bombas/BombasCentrifugas';
import BombasAutocebantes from './Components/Bombas/BombasAutocebantes';
import BombasMultietapas from './Components/Bombas/BombasMultietapas';
import BombasSumergibles from './Components/Bombas/BombasSumergibles';
import BombasEyectoras from './Components/Bombas/BombasEyectoras';
import BombasDiafragma from './Components/Bombas/BombasDiafragma';
import BombasTornillo from './Components/Bombas/BombasTornillo';
import BombasLobulo from './Components/Bombas/BombasLobulo';
import BombasEngranaje from './Components/Bombas/BombasEngranaje';
import BombasTurbinaVertical from './Components/Bombas/BombasTurbinaVertical';
import EquiposDePresion from './Components/EquiposDePresion';
import EquiposDePresionConstante from './Components/EquiposDePresion/EquiposDePresionConstante';
import EquiposDePresionDiferencial from './Components/EquiposDePresion/EquiposDePresionDiferencial';
import SistemaContraIncendiosNormalizados from './Components/SistemaContraIncendiosNormalizados';
import CarcasaPartida from './Components/SistemaContraIncendiosNormalizados/CarcasaPartida';
import SuccionFinal from './Components/SistemaContraIncendiosNormalizados/SuccionFinal';
import TurbinaEjeVertical from './Components/SistemaContraIncendiosNormalizados/TurbinaEjeVertical';
import VerticalEnLinea from './Components/SistemaContraIncendiosNormalizados/VerticalEnLinea';
import SistemaContraIncendiosNoNormalizados from './Components/SistemaContraIncendiosNoNormalizados';
import OtrosEquipos from './Components/OtrosEquipos';
import EquipoEyector from './Components/OtrosEquipos/EquipoEyector';
import EquipoLlenadoTanque from './Components/OtrosEquipos/EquipoLlenadoTanque';
import EquipoOilGas from './Components/OtrosEquipos/EquipoOilGas';
import EquipoRiegoDrenaje from './Components/OtrosEquipos/EquipoRiegoDrenaje';
import Nosotros from './Components/Nosotros';
import EnfoqueEstrategico from './Components/EnfoqueEstrategico';
import Queofrecemos from './Components/Queofrecemos';
import SectoresQueAtendemos from './Components/SectoresQueAtendemos';
import Certificaciones from './Components/Certificaciones';
import Contactanos from './Components/Contactanos';
import Footer from './Layouts/Footer';

function App() {
  return (
    <div className='App'>
      <BrowserRouter>
        <Routes>
          <Route path='/' element={<Header />}>
            <Route index element={<Homepage />} />
            <Route path='Productos' element={<Products />} />
            <Route path='Bombas' element={<Bombas />} />
            <Route path='BombasCentrifugas' element={<BombasCentrifugas />} />
            <Route path='BombasAutocebantes' element={<BombasAutocebantes />} />
            <Route path='BombasMultietapas' element={<BombasMultietapas />} />
            <Route path='BombasSumergibles' element={<BombasSumergibles />} />
            <Route path='BombasEyectoras' element={<BombasEyectoras />} />
            <Route path='BombasDiafragma' element={<BombasDiafragma />} />
            <Route path='BombasTornillo' element={<BombasTornillo />} />
            <Route path='BombasLobulo' element={<BombasLobulo />} />
            <Route path='BombasEngranaje' element={<BombasEngranaje />} />
            <Route path='BombasTurbinaVertical' element={<BombasTurbinaVertical />} />
            <Route path='EquiposDePresion' element={<EquiposDePresion />} />
            <Route path='EquiposDePresionConstante' element={<EquiposDePresionConstante />} />
            <Route path='EquiposDePresionDiferencial' element={<EquiposDePresionDiferencial />} />
            <Route path='SistemaContraIncendiosNormalizados' element={<SistemaContraIncendiosNormalizados />} />
            <Route path='CarcasaPartida' element={<CarcasaPartida />} />
            <Route path='SuccionFinal' element={<SuccionFinal />} />
            <Route path='TurbinaEjeVertical' element={<TurbinaEjeVertical />} />
            <Route path='VerticalEnLinea' element={<VerticalEnLinea />} />
            <Route path='SistemaContraIncendiosNoNormalizados' element={<SistemaContraIncendiosNoNormalizados />} />
            <Route path='OtrosEquipos' element={<OtrosEquipos />} />
            <Route path='EquipoEyector' element={<EquipoEyector />} />
            <Route path='EquipoLlenadoTanque' element={<EquipoLlenadoTanque />} />
            <Route path='EquipoOilGas' element={<EquipoOilGas />} />
            <Route path='EquipoRiegoDrenaje' element={<EquipoRiegoDrenaje />} />
            <Route path='Nosotros' element={<Nosotros />} />
            <Route path='EnfoqueEstrategico' element={<EnfoqueEstrategico />} />
            <Route path='QueOfrecemos' element={<Queofrecemos />} />
            <Route path='SectoresQueAtendemos' element={<SectoresQueAtendemos />} />
            <Route path='Certificaciones' element={<Certificaciones />} />
            <Route path="/Contactanos" element={<Contactanos />} />
            <Route path='*' element={<Navigate replace to='/' />} />
            <Route path='Footer' element={<Footer />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
